import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { thunkErrorHandler } from '@wajeez-web/core/utils';

export const getAllPolicies: ApiMethod<
  void,
  Server.PolicyOutput[],
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getPolicyById: ApiMethod<
  number,
  Server.PolicyOutput,
  any
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_id_get_V1(id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getPolicyById', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getPolicyByIdMultilingual: ApiMethod<
  number,
  Server.PolicyMultilingualOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Policies_Client(
        undefined,
        identityClient
      );

      const response = await client.admin_Policies_multilingualById_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPoliciesByType: ApiMethod<
  { type: Server.PolicyType; languageId?: string },
  Server.PolicyOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_byType_get_V1(
      data.languageId,
      data.type
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(error.response)?.errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
  }
};

export const createNewPolicy: ApiMethod<
  Server.CreatePolicyInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_post_V1(variables);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createPolicyMultilingual: ApiMethod<
  Server.CreatePolicyV2Input,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Policies_Client(
        undefined,
        identityClient
      );

      const response = await client.admin_Policies_post_V2(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const editPolicyMultilingual: ApiMethod<
  Server.EditPolicyV2Input,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Policies_Client(
        undefined,
        identityClient
      );

      const response = await client.admin_Policies_put_V2(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const editPolicy: ApiMethod<
  Server.EditPolicyInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_put_V1(variables);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('editPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deletePolicy: ApiMethod<number, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Policies_Client(undefined, identityClient);
    const response = await client.policies_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('deletePolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
